import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import {
  ConstructionDocumentsGetFileResponse,
  ConstructionDocumentsResponse,
} from '../entities/construction-documents-entities';

const BASE_URL = `${environment.constructionDocumentsApiUrl}`;

@Injectable({
  providedIn: 'root',
})
export class ConstructionDocumentsApiService {
  constructor(private http: HttpClient) {}

  getFolder$(urlPath: string) {
    return this.http.get<ConstructionDocumentsResponse>(
      `${BASE_URL}/construction-documents/${urlPath}`,
    );
  }

  getFile$(ifsNumber: string, itemId: string) {
    return this.http.get<ConstructionDocumentsGetFileResponse>(
      `${BASE_URL}/construction-documents/${ifsNumber}/${itemId}/download`,
    );
  }
}
